import { Box } from '@palmetto/palmetto-components';

import './ProgressBar.css';

type ProgressBarProps = {
  completed: number;
  total: number;
};

export const ProgressBar = ({ completed, total }: ProgressBarProps) => {
  const percentage = (completed / total) * 100;

  return (
    <Box width="100%" borderWidth="xs" borderColor="separator">
      <Box className="fill-card" width={`${percentage}%`}>
        &nbsp;
      </Box>
    </Box>
  );
};
